<div class="{uiClasses}table">
  <slot></slot>
</div>
